import {
  STUDENT_FIELD_TYPES,
  STUDENT_FIELD_TYPE_OPTIONS,
  getStudentFieldTypeLabel,
  isTruthySetting,
} from './studentProfileFields'

export const EMPLOYEE_CUSTOM_FIELDS_SETTING_KEY = 'customFieldsColleagues'
export const EMPLOYEE_PROFILE_FIELDS_SETTINGS_KEY =
  'employeeProfileFieldsSettings'

export const EMPLOYEE_FIELD_TYPES = STUDENT_FIELD_TYPES

export const EMPLOYEE_FIELD_TYPE_OPTIONS = STUDENT_FIELD_TYPE_OPTIONS

export const EMPLOYEE_PROFILE_SYSTEM_FIELDS = [
  {
    id: 'name',
    label: 'ФИО',
    type: EMPLOYEE_FIELD_TYPES.TEXT,
    valueKey: 'name',
    activeLocked: true,
    can_active: false,
    fixed: true,
  },
  {
    id: 'phone',
    label: 'Номер телефона',
    type: EMPLOYEE_FIELD_TYPES.PHONE,
    valueKey: 'phone',
    activeSetting: 'showPhoneColleagues',
    fixed: true,
  },
  {
    id: 'email',
    label: 'Почта',
    type: EMPLOYEE_FIELD_TYPES.TEXT,
    valueKey: 'email',
    activeSetting: 'showEmailColleagues',
    required: true,
    can_required: true,
    fixed: true,
  },
  {
    id: 'login',
    label: 'Логин',
    type: EMPLOYEE_FIELD_TYPES.TEXT,
    valueKey: 'login',
    activeSetting: 'showLoginColleagues',
    defaultActive: false,
  },
  {
    id: 'sex',
    label: 'Пол',
    type: EMPLOYEE_FIELD_TYPES.SELECT,
    valueKey: 'sex',
    activeSetting: 'showGenderColleagues',
    value_options: ['Мужской', 'Женский'],
  },
  {
    id: 'birthDate',
    label: 'Дата рождения',
    type: EMPLOYEE_FIELD_TYPES.DATE,
    valueKey: 'birth_date',
    activeSetting: 'showBirthDateColleagues',
  },
  {
    id: 'city',
    label: 'Город',
    type: EMPLOYEE_FIELD_TYPES.TEXT,
    valueKey: 'city',
    activeSetting: 'showCityColleagues',
  },
  {
    id: 'address',
    label: 'Адрес регистрации',
    type: EMPLOYEE_FIELD_TYPES.TEXT,
    valueKey: 'address',
    activeSetting: 'showRegistrationAddressColleagues',
  },
  {
    id: 'education',
    label: 'Образование',
    type: EMPLOYEE_FIELD_TYPES.TEXT,
    valueKey: 'education',
    activeSetting: 'showEducationColleagues',
  },
  {
    id: 'experience',
    label: 'Опыт работы',
    type: EMPLOYEE_FIELD_TYPES.TEXT,
    valueKey: 'experience',
    activeSetting: 'showWorkExperienceColleagues',
  },
  {
    id: 'socialLink',
    label: 'Ссылка на соц. сеть',
    type: EMPLOYEE_FIELD_TYPES.LINK,
    valueKey: 'link_to_vk',
    activeSetting: 'showSocialLinkColleagues',
  },
  {
    id: 'conferenceLink',
    label: 'Ссылка на ВКС',
    type: EMPLOYEE_FIELD_TYPES.LINK,
    valueKey: 'url_conference',
    activeSetting: 'showVksLinkColleagues',
  },
  {
    id: 'about',
    label: 'О себе',
    type: EMPLOYEE_FIELD_TYPES.TEXTAREA,
    valueKey: 'about',
    activeSetting: 'showAboutMeColleagues',
  },
  {
    id: 'departments',
    label: 'Отделы',
    type: EMPLOYEE_FIELD_TYPES.TECHNICAL,
    activeSetting: 'showDepartmentsColleagues',
  },
  {
    id: 'rating',
    label: 'Рейтинг',
    type: EMPLOYEE_FIELD_TYPES.TECHNICAL,
    activeSetting: 'showRatingColleagues',
  },
  {
    id: 'gamificationExperience',
    label: 'Опыт',
    type: EMPLOYEE_FIELD_TYPES.TECHNICAL,
    activeSetting: 'showGamificationExperienceColleagues',
    defaultActive: true,
  },
  {
    id: 'gamificationBalance',
    label: 'Игровая валюта',
    type: EMPLOYEE_FIELD_TYPES.TECHNICAL,
    activeSetting: 'showGamificationBalanceColleagues',
    defaultActive: true,
  },
  {
    id: 'workSchedule',
    label: 'Рабочее расписание',
    type: EMPLOYEE_FIELD_TYPES.TECHNICAL,
    activeSetting: 'showWorkScheduleColleagues',
  },
  {
    id: 'contracts',
    label: 'Договоры',
    type: EMPLOYEE_FIELD_TYPES.TECHNICAL,
    activeSetting: 'showContractsColleagues',
  },
]

const EMPLOYEE_API_FIELD_ID_BY_NAME = {
  name: 'name',
  phone: 'phone',
  email: 'email',
  login: 'login',
  sex: 'sex',
  birth_date: 'birthDate',
  city: 'city',
  address: 'address',
  education: 'education',
  experience: 'experience',
  link_to_vk: 'socialLink',
  url_conference: 'conferenceLink',
  about: 'about',
  departments: 'departments',
  rating: 'rating',
  gamification_experience: 'gamificationExperience',
  gamification_balance: 'gamificationBalance',
  work_schedule: 'workSchedule',
  contracts: 'contracts',
}

const EMPLOYEE_SYSTEM_FIELD_BY_ID = EMPLOYEE_PROFILE_SYSTEM_FIELDS.reduce(
  (acc, field) => {
    acc[field.id] = field
    return acc
  },
  {},
)

const safeJsonParse = (value, fallback) => {
  if (Array.isArray(value) || (value && typeof value === 'object')) return value
  if (!value || typeof value !== 'string') return fallback

  try {
    return JSON.parse(value)
  } catch {
    return fallback
  }
}

const getFiniteNumber = (value, fallback) => {
  if (value === undefined || value === null || value === '') return fallback
  const number = Number(value)
  return Number.isFinite(number) ? number : fallback
}

export const parseEmployeeFieldSettings = (value) => {
  const parsed = safeJsonParse(value, {})

  return {
    sorting:
      parsed?.sorting && typeof parsed.sorting === 'object'
        ? parsed.sorting
        : {},
    profileVisible:
      parsed?.profileVisible && typeof parsed.profileVisible === 'object'
        ? parsed.profileVisible
        : {},
    profileEditable:
      parsed?.profileEditable && typeof parsed.profileEditable === 'object'
        ? parsed.profileEditable
        : {},
  }
}

export const normalizeEmployeeCustomField = (field, index = 0) => {
  const rawType = field?.type ?? EMPLOYEE_FIELD_TYPES.TEXT
  const type = Object.values(EMPLOYEE_FIELD_TYPES).includes(rawType)
    ? rawType
    : EMPLOYEE_FIELD_TYPES.TEXT
  const fallbackName = `custom_employee_${Date.now()}_${index}`

  return {
    id: field?.id ?? field?.name ?? fallbackName,
    name: String(field?.name ?? fallbackName),
    label: String(field?.label ?? field?.name ?? ''),
    type,
    value_options: Array.isArray(field?.value_options)
      ? field.value_options
      : Array.isArray(field?.fields)
      ? field.fields.map((item) => item?.label ?? item?.name).filter(Boolean)
      : [],
    is_active: isTruthySetting(field?.is_active, true),
    required: isTruthySetting(field?.required ?? field?.is_required, false),
    profile_visible: isTruthySetting(field?.profile_visible, false),
    profile_editable:
      isTruthySetting(field?.profile_visible, false) &&
      isTruthySetting(field?.profile_editable, false),
    employee_visible: isTruthySetting(field?.employee_visible, true),
    sales_manager_visible: isTruthySetting(field?.sales_manager_visible, true),
    teacher_visible: isTruthySetting(field?.teacher_visible, true),
    sorting:
      field?.sorting === undefined || field?.sorting === null
        ? null
        : getFiniteNumber(field.sorting, index + 1),
    isCustom: true,
    is_system: false,
    can_active: isTruthySetting(field?.can_active, true),
    can_required: isTruthySetting(field?.can_required, true),
    can_profile_visible: isTruthySetting(field?.can_profile_visible, true),
    can_profile_editable: isTruthySetting(field?.can_profile_editable, true),
  }
}

const normalizeEmployeeSystemField = (field, index = 0) => {
  const systemId =
    EMPLOYEE_API_FIELD_ID_BY_NAME[field?.name] ??
    EMPLOYEE_API_FIELD_ID_BY_NAME[field?.id] ??
    field?.name ??
    field?.id
  const baseField = EMPLOYEE_SYSTEM_FIELD_BY_ID[systemId]

  if (!baseField) return null

  return {
    ...baseField,
    profileFieldId: field.id,
    fieldName: field.name,
    label: String(field?.label ?? baseField.label),
    type: field?.type ?? baseField.type,
    value_options: field?.value_options ?? baseField.value_options,
    is_active: isTruthySetting(field?.is_active, true),
    required: isTruthySetting(field?.is_required, false),
    profile_visible: isTruthySetting(field?.profile_visible, false),
    profile_editable:
      isTruthySetting(field?.profile_visible, false) &&
      isTruthySetting(field?.profile_editable, false),
    employee_visible: isTruthySetting(field?.employee_visible, true),
    sales_manager_visible: isTruthySetting(field?.sales_manager_visible, true),
    teacher_visible: isTruthySetting(field?.teacher_visible, true),
    can_active: isTruthySetting(
      field?.can_active,
      Boolean(baseField.activeSetting),
    ),
    can_required: isTruthySetting(
      field?.can_required,
      Boolean(baseField.can_required),
    ),
    can_profile_visible: isTruthySetting(field?.can_profile_visible, true),
    can_profile_editable: isTruthySetting(field?.can_profile_editable, true),
    sorting:
      field?.sorting === undefined || field?.sorting === null
        ? index + 1
        : getFiniteNumber(field.sorting, index + 1),
    isCustom: false,
    is_system: true,
  }
}

export const parseEmployeeCustomFields = (value) => {
  const parsed = safeJsonParse(value, [])
  if (!Array.isArray(parsed)) return []

  return parsed
    .filter((field) => !field?.is_system)
    .map(normalizeEmployeeCustomField)
}

export const parseEmployeeProfileApiFields = (value) => {
  const parsed = safeJsonParse(value, [])
  if (!Array.isArray(parsed)) return { systemFields: [], customFields: [] }

  return parsed.reduce(
    (acc, field, index) => {
      if (field?.is_system) {
        const systemField = normalizeEmployeeSystemField(field, index)
        if (systemField) acc.systemFields.push(systemField)
        return acc
      }

      acc.customFields.push(normalizeEmployeeCustomField(field, index))
      return acc
    },
    { systemFields: [], customFields: [] },
  )
}

export const getEmployeeFieldTypeLabel = getStudentFieldTypeLabel

export const isEmployeeFieldActive = (field, platformSettings) => {
  if (field.activeLocked) return true
  if (field.profileFieldId || field.is_system)
    return isTruthySetting(field.is_active, true)
  if (field.isCustom) return isTruthySetting(field.is_active, true)
  if (!field.activeSetting) return true
  return isTruthySetting(
    platformSettings?.[field.activeSetting],
    field.defaultActive ?? true,
  )
}

export const isTextareaEmployeeField = (field) =>
  field.type === EMPLOYEE_FIELD_TYPES.TEXTAREA

export const getEmployeeProfileFields = (
  platformSettings = {},
  customFieldsSource,
  includeInactive = false,
) => {
  const fieldSettings = parseEmployeeFieldSettings(
    platformSettings?.[EMPLOYEE_PROFILE_FIELDS_SETTINGS_KEY] ??
      platformSettings?.custom?.[EMPLOYEE_PROFILE_FIELDS_SETTINGS_KEY],
  )
  const apiFields = parseEmployeeProfileApiFields(customFieldsSource)
  const customFields = customFieldsSource
    ? apiFields.customFields
    : parseEmployeeCustomFields(
        platformSettings?.[EMPLOYEE_CUSTOM_FIELDS_SETTING_KEY],
      )
  const fallbackSystemFields = EMPLOYEE_PROFILE_SYSTEM_FIELDS.map((field) => {
        const profileVisible = isTruthySetting(
          fieldSettings.profileVisible[field.id],
          true,
        )

        return {
          ...field,
          profile_visible: profileVisible,
          profile_editable:
            profileVisible &&
            isTruthySetting(fieldSettings.profileEditable[field.id], true),
          isCustom: false,
        }
      })
  const persistedSystemFields = apiFields.systemFields.reduce((acc, field) => {
    acc[field.id] = field
    return acc
  }, {})
  const systemFields = fallbackSystemFields.map(
    (field) => persistedSystemFields[field.id] ?? field,
  )
  const allFields = [...systemFields, ...customFields]
  let regularSorting = 0
  let textAreaSorting = 0

  return allFields
    .filter(
      (field) =>
        includeInactive || isEmployeeFieldActive(field, platformSettings),
    )
    .map((field) => {
      const fallbackSorting = isTextareaEmployeeField(field)
        ? (textAreaSorting += 1)
        : (regularSorting += 1)

      return {
        ...field,
        defaultSorting: fallbackSorting,
        sorting:
          field.profileFieldId || field.isCustom || field.is_system
            ? getFiniteNumber(field.sorting, fallbackSorting)
            : getFiniteNumber(fieldSettings.sorting[field.id], fallbackSorting),
      }
    })
    .sort((a, b) => {
      const aTextarea = isTextareaEmployeeField(a)
      const bTextarea = isTextareaEmployeeField(b)
      if (aTextarea !== bTextarea) return aTextarea ? 1 : -1
      return (
        Number(a.sorting ?? a.defaultSorting) -
        Number(b.sorting ?? b.defaultSorting)
      )
    })
}
